import { useQuery } from "@tanstack/react-query";
import merchantUserService from "..";

function useGetMerchantUserById(id: number) {
  return useQuery({
    queryKey: ["getMerchantUsersById", id],
    queryFn: () => merchantUserService.getMerchantUserById(id),
    select: (res) => res,
    enabled: id != 0,
  });
}

export default useGetMerchantUserById;
